/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import FilterListIcon from "@mui/icons-material/FilterList";
import { MdOutlineErrorOutline } from "react-icons/md";
import { Button } from "@material-ui/core";
import { Link } from "react-router-dom";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { useAppDispatch } from "../../../useStore";
import { reset } from "../../../features/Applicant/applicantSlice";
import { EntriesPerPage, Search, TableFetch } from "../../../components/TableOptions";
import ShareModal from "../../../components/ModalComponents/ShareModal";
import Pagination from "../../../components/Pagination";
import toast, { Toaster } from "react-hot-toast";
import XLoader from "../../../components/XLoader";
import { FaFilePdf, FaFileCsv, FaFileImage, FaFile } from "react-icons/fa";
import ImageLightbox from "../../../components/ImageLightbox";
import PdfViewer from "../../../components/PdfViewer";
import BackToScreeningModal from "../../../components/ModalComponents/BackToScreeningModal";
import moment from "moment";
import EditApplicant from "../../../components/ModalComponents/EditApplicant";
import ReplaceID from "../../../components/ModalComponents/ReplaceID";


const DropoutTable = ({
  pageHeader,
  headerTitles,
  statusButton,
  Status,
  data,
  isLoading,
  message,
  isError,
  setResetID
}: any) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (isError) {
      toast.error(message);
    }
    dispatch(reset());
  }, [dispatch, isError, message]);

  const [datas, setDatas] = useState([]);
  const [searchItem, setSearchItem] = useState("");
  const [entriesperpage, setEntriesPerPage] = useState(() => {
    return "8";
  });

  const dropout = data?.data?.filter((obj: any) => {
    return obj?.applicationStatus === "DROPOUT"
  })

  const [show, setShow] = useState(false);
  const [isPDF, setIsPDF] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);

  const openModal = (fileUrl: any, fileType: string, file: React.SetStateAction<null>) => {
    setSelectedFile(file);
    setIsPDF(fileType === 'pdf');
    setShow(true);
  };


  const getFileIcon = (fileType: any) => {
    switch (fileType) {
      case 'pdf':
        return <FaFilePdf color={"red"} size={25} />;
      case 'csv':
        return <FaFileCsv size={25} color={"green"} />;
      case 'jpeg':
      case 'jpg':
      case 'png':
        return <FaFileImage size={25} color={"gray"} />;
      default:
        return <FaFile size={25} />;
    }
  };

  useEffect(() => {
    const result = dropout?.filter((item: any) =>
      item?.firstName?.toLowerCase()?.includes(searchItem) ||
      item?.middleName?.toLowerCase()?.includes(searchItem) ||
      item?.LastName?.toLowerCase()?.includes(searchItem)
    );
    setDatas(result);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, searchItem]);

  const [displayData, setDisplayData] = useState([]);



  return (
    <div>
      <Toaster
        position="top-center"
        toastOptions={{
          duration: 5000,
          error: {
            duration: 20000,
          },
        }}
      />

      <section className="md-ui component-data-table">
        <header className="main-table-header">
          <div className="main-table-search-container">
            <h1 className="table-header--title">{pageHeader}</h1>
            <Search searchItem={searchItem} setSearchItem={setSearchItem} placeholder={pageHeader} />
            <div>
              <EntriesPerPage
                data={datas}
                entriesperpage={entriesperpage}
                setEntriesPerPage={setEntriesPerPage}
              />
            </div>
            <span className="table-header--icons">
              <FilterListIcon />
            </span>
          </div>
        </header>
        {isLoading && <XLoader isLoading={isLoading} />}
        <div className="main-table-wrapper">
          <table className="main-table-content">
            <thead className="data-table-header">
              <tr className="data-table-row">
                {headerTitles.map((title: any, i: any) => (
                  <td className="table-datacell datatype-string headerTitles"
                    key={i} >
                    {title}
                  </td>
                ))}
              </tr>
            </thead>
            <tbody className="data-table-content">
              {isLoading ? (
                <TableFetch colSpan={12} />
              ) : displayData?.length === 0 ||
                displayData?.length === undefined ? (
                <tr>
                  <td className="table-msg" colSpan={13}>
                    <MdOutlineErrorOutline size={75} />
                    <p>No Record found!</p>
                  </td>
                </tr>
              ) : (
                displayData?.map((item: any, i: any) => (
                  <tr className="data-table-row" key={i}>
                    <td className="table-datacell datatype-string">
                      <div className="dropdown">
                        <button className="dropbtn">
                          <MoreHorizIcon />
                        </button>
                        <div className="dropdown-content">
                          <a>
                            <BackToScreeningModal
                              title={"Send for Screening"}
                              name={[item]}
                              id={item?.id} />
                          </a>
                          <a>
                            <ShareModal title={"Share"} applicationId={item?.id} />
                          </a>
                        </div>
                      </div>
                    </td>

                    <td className="table-datacell datatype-string">
                      {!item.firstName ? "" : item.firstName} {!item.middleName ? "" : item.middleName} {!item.LastName ? "" : item.LastName}
                    </td>
                    <td className="table-datacell datatype-string">
                      {item?.gender}
                    </td>
                    <td className="table-datacell datatype-string">
                      {moment(!item?.dateOfBirth ? "n/a" : item?.dateOfBirth).format("DD-MM-YYYY")}
                    </td>
                    <td className="table-datacell datatype-string">
                      {moment(item?.createdAt).format("DD-MM-YYYY")}
                    </td>

                    <td className="table-datacell datatype-string">
                      <Link
                        to={`/viewapplicants/${item?.id}`}
                        className="applicant-btn"
                      >
                        <Button className="view-job-profile">View</Button>
                      </Link>
                    </td>
                    <td className="table-datacell datatype-string">
                      {item?.verificationID
                        ? (
                          <div className="table-datacell-flex">
                          <span
                            style={{ marginRight: '5px', cursor: 'pointer' }}
                            onClick={() => {
                              const fileExtension = item?.verificationID.split('.').pop().toLowerCase();
                              openModal(item?.verificationID, fileExtension, item?.verificationID,);
                            }}>
                            {getFileIcon(item?.verificationID.split('.').pop().toLowerCase())}
                          </span>
                          <ReplaceID id={item?.id} setResetID={setResetID} />
                          </div>
                        )
                        : <div className="table-datacell-flex">
                            <span>
                              No ID
                            </span>
                            <ReplaceID id={item?.id} setResetID={setResetID} />
                          </div>
                      }
                    </td>
                    <td className="table-datacell datatype-numeric">
                      <Button className={statusButton}>{Status}</Button>
                    </td>

                    <td className="table-datacell datatype-numeric">
                      {!item?.phoneNumber ? "n/a" : item?.phoneNumber}
                    </td>


                    <td className="table-datacell datatype-numeric">
                      {item?.email}
                    </td>

                    <td className="table-datacell datatype-string">
                      {item?.phoneNumber}
                    </td>
                    <td className="table-datacell datatype-string">
                      {!item?.relevantWorkExperience
                        ? "n/a"
                        : item?.relevantWorkExperience}
                    </td>

                    <td className="table-datacell datatype-string">
                      {!item?.totalWorkExperience
                        ? "n/a"
                        : item?.totalWorkExperience}
                    </td>


                    <td className="table-datacell datatype-string"> {!item?.location
                      ? "n/a"
                      : item?.location}</td>

                    <td className="table-datacell datatype-string">
                      {!item?.currentSalary ? "n/a" : item?.currentSalary}
                    </td>

                    <td className="table-datacell datatype-string">
                      {!item?.expectedSalary ? "n/a" : item?.expectedSalary}
                    </td>
                    <td className="table-datacell datatype-string">
                      <EditApplicant name={item} id={item?.id} />
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
          {isPDF ? (
            <PdfViewer fileUrl={selectedFile} setShow={setShow} show={show} />
          ) : (
            <ImageLightbox images={selectedFile} setShow={setShow} show={show} />
          )}
        </div>
        <div className="table-footer">


          <div>
            <Pagination
              setDisplayData={setDisplayData}
              data={datas}
              entriesperpage={entriesperpage}
              Total={"Drop Out"}
            />
          </div>

        </div>
      </section>
    </div>
  );
};

export default DropoutTable;
